import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=3e3c2884&scoped=true"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=3e3c2884&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c2884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3c2884')) {
      api.createRecord('3e3c2884', component.options)
    } else {
      api.reload('3e3c2884', component.options)
    }
    module.hot.accept("./Dataset.vue?vue&type=template&id=3e3c2884&scoped=true", function () {
      api.rerender('3e3c2884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/task/Dataset.vue"
export default component.exports